import React from 'react';
import { About } from "../components/landing/About.tsx";
import { LandingPageFAQ } from "../components/landing/FAQ.tsx";
// import { Features } from "../components/landing/Features.tsx";
import { Hero } from "../components/landing/Hero.tsx";
import { HowItWorks } from "../components/landing/HowItWorks.tsx";
import { ScrollToTop } from "../components/ScrollToTop";

const LandingPage: React.FC = () => {
    return (
        <>
            <Hero />
            <About />
            <HowItWorks />
            {/*<Features />*/}
            <LandingPageFAQ />
            <ScrollToTop />
        </>
    );
}

export default LandingPage;
